import { throwRepoErrorFromApiV3Error } from '@webapp/core/utils/repositories/throwRepoErrorFromApiV3Error'
import { type IHttpClient } from '@webapp/infrastructure/interfaces/services/IHttpClient'
import {
  type IApprovalChainRepository,
  type ListBillApprovalChainsResult,
} from '@webapp/platform/approval-routing/business-logic/interfaces/IApprovalChainRepository'
import { type BillApprovalChainApiModel } from '@webapp/platform/approval-routing/data-access/api-models/BillApprovalChainApiModel'
import { mapBillApprovalChainApiModel } from '@webapp/platform/approval-routing/data-access/mappers/mapBillApprovalChainApiModel'

export const BILL_APPROVAL_CHAINS_URL =
  '/api/v2/ap/approval-chains/requestable/'

interface Dependency {
  httpClient: IHttpClient
}

interface ListBillApprovalChainsResponse {
  data: BillApprovalChainApiModel[]
  metadata?: {
    skip_bill_approval?: boolean
  }
}

export class ApprovalChainRepository implements IApprovalChainRepository {
  constructor(private readonly deps: Dependency) {}

  async listBillApprovalChains(): Promise<ListBillApprovalChainsResult> {
    try {
      const res =
        await this.deps.httpClient.get<ListBillApprovalChainsResponse>(
          BILL_APPROVAL_CHAINS_URL,
          {
            params: {
              format: 'json',
              // Bill approval chains (Angular `ApprovalRoutingAPI.bills`).
              type: 0,
              page_size: 9999,
            },
          }
        )

      return {
        chains: res.data.data.map(mapBillApprovalChainApiModel),
        skipApproval: res.data.metadata?.skip_bill_approval ?? false,
      }
    } catch (err) {
      throw throwRepoErrorFromApiV3Error(err)
    }
  }
}
